//@ts-nocheck
import { useEffect } from 'react';
import { observer } from 'mobx-react';

import s from './styles.module.scss';
import Step1 from './Step1';
import Step2 from './Step2';
import { makeAutoObservable } from 'mobx';
import { about } from '../AboutCompany';
import userStore from 'store/User';
import { authorizedRequest } from 'utils/authorization';
class ContactPersonBC {
  constructor() {
    makeAutoObservable(this);
  }

  page = 1;

  values = { step1Variant: '' };

  isStepIsValid = {
    1: false,
    2: false,
  };

  isDataSended = false;
  contactId = '';

  get isContactPersonValid() {
    return this.isStepIsValid[2];
  }

  get isLastStep() {
    // При завершенном онбординге - редактирование на одной странице
    if (contactPersonInst.isDataSended) return this.page === 1;
    // При первичном заполнении - последний шаг это Step2
    return this.page === 2;
  }

  get hasContact() {
    return about.values.contacts.find((item) => item.type === 'contact');
  }

  // Метод для сравнения контактов и определения связи с подписантом
  private areContactsEqual(contact: any, signer: any): boolean {
    if (!contact || !signer) return false;

    return (
      contact.first_name === signer.first_name &&
      contact.last_name === signer.last_name &&
      contact.email === signer.email &&
      contact.position === signer.position
    );
  }

  // Загрузка данных контактов из API
  loadContactData = async () => {
    if (!userStore.me?.company?.id) return;

    try {
      const contacts = await authorizedRequest({
        url: `/v1/companies/${userStore.me.company.id}/contacts`,
        service: 'fca',
        method: 'GET',
      });

      if (contacts && Array.isArray(contacts)) {
        // Обновляем контакты в about.values
        about.values.contacts = contacts;
      }

      // Устанавливаем статус завершенности на основе данных с сервера
      if (!this.isDataSended) {
        this.isDataSended = userStore.onboardingSteps?.contactPerson ?? false;
      }
    } catch (error) {
      console.error('Failed to load contact data:', error);
    }
  };

  //@ts-ignore
  init(contact) {
    if (contact && contact?.full_name) {
      this.contactId = contact.id;

      // Определяем был ли контакт связан с подписантом
      const signer = about.values.contacts.find(
        (item) => item.type === 'signer',
      );
      if (signer && this.areContactsEqual(contact, signer)) {
        this.values.step1Variant = 'yes';
      } else {
        this.values.step1Variant = 'no';
      }

      // При редактировании валидируем шаги
      this.isStepIsValid[1] = true; // Step1 валиден если есть выбор
      // isStepIsValid[2] будет установлен Step2 компонентом после валидации формы
    }
    // Не сбрасываем isDataSended если данные уже были отправлены локально
    if (!this.isDataSended) {
      this.isDataSended = userStore.onboardingSteps?.contactPerson ?? false;
    }
  }
}

export const contactPersonInst = new ContactPersonBC();

const ContactPerson = observer(() => {
  // Синхронизируем данные при открытии компонента
  // loadContactData уже вызван в App.tsx, просто копируем данные в локальное состояние
  useEffect(() => {
    const currentContact = about.values.contacts.find(
      (item) => item.type === 'contact',
    );
    if (currentContact) {
      contactPersonInst.init(currentContact);
    }
  }, []);

  const getPage = (page: number) => {
    const currentContact = about.values.contacts.find(
      (item) => item.type === 'contact',
    );

    // Если онбординг завершен - показываем только форму редактирования
    if (contactPersonInst.isDataSended && currentContact) {
      return <Step2 />;
    }

    // При первичном заполнении или редактировании незавершенного - показываем правильную страницу
    switch (page) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      default:
        return <div />;
    }
  };

  return (
    <div>
      <div className={s.container}>{getPage(contactPersonInst.page)}</div>
    </div>
  );
});

export default ContactPerson;
